import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Popover from './components/Popover';
import FilterStatus from './components/FilterStatus';
import updateCategories from './helpers/updateCategories';

class Filter extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            categories: props.categories
        };
    }

    componentWillReceiveProps({ categories }) {
        this.setState({ categories });
    }

    /**
     * When some option is changed we are using two reducers
     * (one that passed through props and one that change selected option)
     * to handle options transformations
     */
    dispatch = (action) => {
        const { categoriesReducer } = this.props;

        this.setState(({ categories }) => ({
            categories: updateCategories(categories, categoriesReducer, action)
        }));
    }

    resetCategories = () => {
        this.setState({ categories: this.props.categories });
    }

    applyFilter = () => {
        this.props.onFilterApply(this.state.categories);
    }

    render() {
        const { children } = this.props;
        const { categories } = this.state;

        if (!categories) return null;

        return (
            <div className="cmn-filter">
                {children ||
                    <FilterStatus categories={this.props.categories} />
                }
                <Popover
                    categories={categories}
                    resetCategories={this.resetCategories}
                    applyFilter={this.applyFilter}
                    dispatch={this.dispatch}
                />
            </div>
        );
    }
}

Filter.defaultProps = {
    categoriesReducer: categories => categories
};

const strOrNum = PropTypes.oneOfType([PropTypes.string, PropTypes.number]);
Filter.propTypes = {
    categories: PropTypes.objectOf(PropTypes.shape({
        title: PropTypes.string.isRequired,
        options: PropTypes.arrayOf(PropTypes.shape({
            value: strOrNum.isRequired,
            label: strOrNum.isRequired,
            statusLabel: strOrNum
        })),
    })),
    categoriesReducer: PropTypes.func,
    children: PropTypes.node,
    onFilterApply: PropTypes.func.isRequired
};

export default Filter;



// WEBPACK FOOTER //
// ./~/rp-react-common/Filter/Filter.jsx